import type { ThemeBundle, ThemeKey } from './types';
import { baselineBundle } from './baseline/theme';
import { editorialBundle } from './editorial';

export type { ThemeBundle, ThemeKey };
export { baselineBundle, editorialBundle };

export function getBundle(key: ThemeKey): ThemeBundle {
  return key === 'editorial' ? editorialBundle : baselineBundle;
}
